export const FETCH_DOMAIN_DETAILS = "FETCH_DOMAIN_DETAILS";
